import Alert from "components/Alert/Alert";
import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import ClientRoutes from "routes/ClientRoutes";
import PublicRoutes from "routes/PublicRoutes";
import "./App.scss";
import PrivateRoutes from "routes/PrivateRoutes";


function App() {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [location]);

  return (
    <>
      {/* <IdleTimer /> */}
      <Routes>
        <Route path="/dashboard/*" element={<PrivateRoutes />} />
        <Route path="/control-panel/*" element={<ClientRoutes />} />
        <Route path="/*" element={<PublicRoutes />} />
      </Routes>
      {/* <a className="btn btn-primary mx-auto" onClick={sendMessage}>++++</a> */}
      {/* <PushNotifications /> */}
      {/* <WebAuth /> */}
      {/* <SystemInfo /> */}
      {/* <EncryptionComponent /> */}

      <Alert />
    </>
  );
}

export default App;

